// redux/app/appSaga.js
import { put, takeLatest } from "redux-saga/effects";
import { setUserFromToken } from "../user/userSlice";
import { loadRecentSearchesRequest } from "../recentSearches/recentSearchesSlice";
import { setAppInitialized } from "./appSlice";

/**
 * Handle app initialization - triggered when the app starts
 * For existing users, we trigger the user login flow to ensure profile data loads
 */
function* handleAppInitialization() {
  try {
    // Get current token from localStorage to trigger user login saga
    const token = localStorage.getItem("token");
    
    if (token) {
      //console.log('App initialized with existing token, triggering user login flow');
      // Dispatch setUserFromToken to trigger the handleUserLogin saga
      // This ensures profile data loads through the standard login flow
      yield put(setUserFromToken(token));
    } else {
      //console.log('App initialized without token');
      // Load recent searches from localStorage for non-authenticated users
      yield put(loadRecentSearchesRequest());
    }
    
    // Mark app as initialized
    yield put(setAppInitialized());
  } catch (err) {
    console.error("Failed during app initialization:", err);
    // Still mark as initialized even on error to prevent hanging
    yield put(setAppInitialized());
  }
}

export default function* appSaga() {
  yield takeLatest("app/initializeApp", handleAppInitialization);
}

// Export individual functions for testing
export { handleAppInitialization };
